import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { createUserWallet, getUserWallet } from "./paymentsAPI";
import { UserCurrency } from "./types";

export interface PaymentsState {
  wallet: UserCurrency[];
  status: "idle" | "loading" | "failed";
}

const initialState: PaymentsState = {
  wallet: null,
  status: "idle",
};

export const getWalletAsync = createAsyncThunk(
  "payments/getWallet",
  async (userId: string) => {
    const wallet = await getUserWallet(userId);
    return wallet;
  }
);

export const createWalletAsync = createAsyncThunk(
  "payments/createWallet",
  async () => {
    const wallet = await createUserWallet();
    return wallet;
  }
);

export const paymentsSlice = createSlice({
  name: "payments",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {},
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(getWalletAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getWalletAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.wallet = action.payload;
      });
    builder
      .addCase(createWalletAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(createWalletAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.wallet = [...state.wallet, action.payload];
      });
  },
});

// export const {} = eventsSlice.actions;

export default paymentsSlice.reducer;
